const InfiniteSentinel = ({ sentinelRef }) => {
  return <div ref={sentinelRef} className="h-px w-full" />;
};

export default InfiniteSentinel;
